//homepage newsletter
$('#newsletter-signup').submit(function (event) {
  event.preventDefault(); //prevent default action

  const post_url = $(this).attr('action'); //get form action url
  const form_data = $(this).serialize(); //Encode form elements for submission
  $.post(post_url, form_data, function (response) {
    if (response.success == false) {
      //show error
      $('#newsletter-signup').append(response.data);
    } else {
      //success is true
      $('#newsletter-signup').slideUp();
      $('#newsletter-success').html(response.data);
      document.cookie = `has_newsletter=true; path=/; max-age=${60 * 60 * 24 * 15}`;
    }
  });
});
